import classNames from 'classnames';
import {useNavigate} from 'react-router-dom';
import EmptyImage from '../../../assets/image/shared/chat_empty_profile_image.svg';
import {useAuth} from '../../../context/authContext';
import styles from './header.module.scss';
const ProfileHeader = () => {
  const {supplierProfile} = useAuth();
  const navigate = useNavigate();
  return (
    <>
      <div
        className={classNames(
          styles['header-profile'],
          'd-flex justify-content-between align-items-center',
        )}
        onClick={() => {
          navigate('/profile/edit');
        }}
      >
        <div className="d-flex">
          <img
            className="rounded-circle"
            src={supplierProfile?.profile_image || EmptyImage}
            alt=""
          />
          <div className="me-3 d-flex flex-column justify-content-center">
            <div>
              <span className="color-gray-1">{supplierProfile?.name}</span>
            </div>
            <div>
              <small className="color-gray-2">
                {supplierProfile?.phone_number}
              </small>
            </div>
          </div>
        </div>
        <div>
          <i className="icon-arrow-left1 color-gray-1"></i>
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;
